// extracted by mini-css-extract-plugin
export default {"select":"RecordCompareSelectAll_select__FlWQM","ripple":"RecordCompareSelectAll_ripple__+3fhl","unselect":"RecordCompareSelectAll_unselect__PiGC7"};